(() => {
  function init(root = document) {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.rwStickyPreviewCleanup) return;
      const image = section.querySelector('[data-sticky-image]');
      const select = section.querySelector('[data-variant-select]');
      const data = section.querySelector('[data-sticky-images]');
      if (!image || !select || !data) return;
      let images;
      try { images = JSON.parse(data.textContent); } catch { return; }
      const update = () => {
        const src = images[select.value];
        image.hidden = !src;
        if (src && image.getAttribute('src') !== src) image.setAttribute('src', src);
      };
      select.addEventListener('change', update);
      update();
      section.rwStickyPreviewCleanup = () => {
        select.removeEventListener('change', update);
        delete section.rwStickyPreviewCleanup;
      };
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-product-section]').forEach(section => section.rwStickyPreviewCleanup?.()));
})();
